import { Directive, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { environment } from '../../../environments/environment';
import { EncodeURIComponentPipe } from '../pipe/encode-uri-component.pipe';

/** 圖片是否支援 Imagor 判斷 */
@Directive({
  selector: 'img[appIsPicSupportImagor]'
})
export class IsPicSupportImagorDirective implements OnInit, OnChanges, OnDestroy {
  public readonly imagorHost: string = environment.imagorHost;
  private _el: HTMLImageElement;
  /** 要判斷是否支援 Imagor 的圖片網址，從外部帶進來的，應該放圖片本身代表圖的網址(未經過imagor) */ 
  @Input('appIsPicSupportImagor') imageUrl: string;
  /** 實際要判斷是否支援 Imagor 的圖片網址 */ 
  private _imageUrl: string;
  /** 是否支援 Imagor */
  private _isSupport = false;
  /** 是否支援 Imagor (唯讀) */
  public get isSupport() {
    return this._isSupport;
  }
  /** 是否支援 Imagor 改變 */
  @Output() isSupportImagorChange = new EventEmitter<boolean>();
  /** 圖片是否載入完成或失敗過 */
  private _isImageLoded = false;
  /** 圖片是否成功載入 */
  private _isImageSuccessLoded = false;
  /** 載入失敗過的網址 */
  private hasLoadErrorImageUrls: string[] = [];
  /** 是否啟動 imagor 圖片支援檢查，預設啟動(true) */
  @Input() enableCheckImagorSupport = true;

  constructor(
    private _elementRef: ElementRef,
  ) {
    this._el = this._elementRef.nativeElement;
  }

  ngOnInit(): void {
    this._el.addEventListener('load', this._onImageLoaded);
    this._el.addEventListener('error', this._onImageError);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes['imageUrl']) {
    //   if (changes['imageUrl'].isFirstChange) { // 只吃第一次帶入的值，之後的不管，這應該只是一個固定的網址不是動態的
    //     if (this.imageUrl) { // 有帶入網址
    //       if (this.imageUrl !== this._imageUrl && this._imageUrl) { // 新設定進來的網址和原本判斷用的不一樣
    //         this._imageUrl = this.imageUrl;
    //         this.checkImageUrlSupport(this._imageUrl)
    //       }
    //     }
    //   }
    // }
  }

  ngOnDestroy(): void {
    this._el.removeEventListener('load', this._onImageLoaded);
    this._el.removeEventListener('error', this._onImageError);
  }

  protected _onImageLoaded = (e) => {
    if (!this.enableCheckImagorSupport) { return; } // 是否有啟用檢查功能

    this._isImageLoded = true;
    this._isImageSuccessLoded = true;

    if (this._imageUrl !== this._el.src) { // 將判斷的網址設定成目前圖片使用的網址
      this._imageUrl = this._el.src;

      if (this._imageUrl.startsWith(this.imagorHost)) { // 如果判斷的圖片網址是 imagor 的就當作支援
        // if (!this._isSupport) {
          this._isSupport = true;
          this.isSupportImagorChange.emit(this._isSupport);
        // }
      } else { // 不是 imagor 的網址，有可能是代表縮圖
        if (this.hasLoadErrorImageUrls.length) { // 這張載入成功前有試過其他張，檢查之前失敗的圖有沒有 imagor 的網址
          const f = this.hasLoadErrorImageUrls.find(url => url.startsWith(this.imagorHost));
          if (f) {
            // if (this._isSupport) {
              this._isSupport = false;
              this.isSupportImagorChange.emit(this._isSupport);
            // }
          }
        } else { // 這張圖是第一張就成功載入的，需要載入一張 imagor 的圖片看看是否支援
          if (!this._el.src.startsWith('/')) { // 不是載入本機的預設圖
            this.checkImageUrlSupport(this.imageUrl)
          } else { // 是載入本機的預設圖
            // if (this._isSupport) {
              this._isSupport = false;
              this.isSupportImagorChange.emit(this._isSupport);
            // }
          }
        }
      }
    }
  };

  protected _onImageError = (e) => {
    if (!this.enableCheckImagorSupport) { return; } // 是否有啟用檢查功能
    this._isImageLoded = true;
    this.hasLoadErrorImageUrls.push(this._el.src);
  };

  checkImageUrlSupport(url: string) {
    if (url.startsWith(this.imagorHost)) { // 如果判斷的圖片網址是 imagor 的就當作支援
      this._isSupport = true;
      return;
    } else { // 如果不是 imagor 網址，就載入一個圖片看看
      const img = new Image();
      const imagorPicSrc = `${this.imagorHost}/fit-in/300x300/${new EncodeURIComponentPipe().transform(url)}`
  
      img.onload = () => {
        // if (!this._isSupport) {
          this._isSupport = true;
          this.isSupportImagorChange.emit(this._isSupport);
        // }
      };
      img.onerror = () => {
        // if (this._isSupport) {
          this._isSupport = false;
          this.isSupportImagorChange.emit(this._isSupport);
        // }
      };
  
      img.src = imagorPicSrc;
    }
  }
}
